/**
 * The match height tool.
 *
 * > npm i jquery-match-height
 *
 * @link https://github.com/liabru/jquery-match-height
 */

import 'jquery-match-height';

$(() => {

  // Make match height.
  $('.js-match-height').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
  });

});
